const EditLine = ({ width = 16, height = 16, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      {...props}
    >
      <path
        d="M4.276 10.6664L11.0373 3.90506L10.0947 2.9624L3.33333 9.72373V10.6664H4.276ZM4.82867 11.9997H2V9.17106L9.62333 1.54773C9.74835 1.42275 9.91789 1.35254 10.0947 1.35254C10.2714 1.35254 10.441 1.42275 10.566 1.54773L12.452 3.43373C12.577 3.55875 12.6472 3.72829 12.6472 3.90506C12.6472 4.08184 12.577 4.25138 12.452 4.3764L4.82867 11.9997ZM2 13.3331H14V14.6664H2V13.3331Z"
        fill={color}
      />
    </svg>
  )
}

export default EditLine
